const navigateTo = (url: string) => {
  window.location.replace(url);
};

export default navigateTo;
